import { createTrackingUtils } from "../index.js";
const utils = createTrackingUtils({
    name: "flights_apex_tabular_branded_fares_sr",
    defaultStage: 1,
    stages: {
        sr_users_with_requestable_bf: 1,
        users_click_on_expanded_bf_button: 2,
        users_open_tooltip: 3,
        multitravellers: 4,
        different_baggage_allowance: 5,
        users_more_than_3_bfs: 6
    },
    goals: {
        user_click_toggle_off: 1,
        user_click_fare_child_offer: 2,
        user_click_fare_child_offer_upsell: 3,
        user_hover_bf_feature_icons: 4,
        user_select_upsell_offer: 5
    },
    goalsWithValue: []
});
const trackStages = () => {
    utils.stages.sr_users_with_requestable_bf();
};
const trackButtonClick = (props) => {
    utils.stages.users_click_on_expanded_bf_button();
    if (props.showFareSelector) {
        utils.goals.user_click_toggle_off();
    }
    if (!props.showFareSelector && props.brandedFareOffersCount > 3) {
        utils.stages.users_more_than_3_bfs();
    }
};
const isInVariant = (variant) => {
    return utils.trackWithDefaultStage() === variant;
};
export default { ...utils, trackStages, trackButtonClick, isInVariant };
